import styled from "styled-components";
import { lighten } from "polished"

export const ButtonContainer = styled.button<{ color: string }>`
  padding: 0.75rem 1rem;
  border: none;
  border-radius: 0.5rem;
  background-color: ${({ color }) => color};
  font-weight: 700;
  color: white;
  transition: 0.2s;

  &:hover {
    background-color: ${({ color }) => lighten(0.1, color)};
  }

  &:disabled {
    cursor: default;
    background-color: #9E9E9E;
  }
`;
